//for build product
// export const apiUrl ="https://localhost:7283/api/";
// export const apiAsset ="https://localhost:7283/uploads/";
// export const apiUrl ="http://94.182.215.101:2014/api/";
// export const apiAsset ="http://94.182.215.101:2014/uploads/";
// export const apiUrl ="https://bonsazeh-back.gwsec.ir/api/";
// export const apiAsset ="https://bonsazeh-back.gwsec.ir/uploads/";
export const apiUrl =window.env.REACT_APP_API_MAIN+"api/";
export const apiAsset =window.env.REACT_APP_API_MAIN+"/uploads/";

export const apiUrlSar =window.env.REACT_APP_API_RAG;
export const apiAssetSar =window.env.REACT_APP_API_RAG;
// export const apiUrlCreateImageSar ="http://94.182.215.101:2013/";
// export const apiUrlCreateImageSar ="https://imagegeneration.bonsazeh.gwsec.ir/";
export const apiUrlCreateImageSar =window.env.REACT_APP_API_IMAGE;
// export const apiUrlWordCloudImageSar ="http://94.182.215.101:2044/";
// export const apiUrlWordCloudImageSar ="https://wordcloud.bonsazeh.gwsec.ir/";
export const apiUrlWordCloudImageSar =window.env.REACT_APP_API_WORDCLOUD;
// export const apiUrlFaceSar ="http://94.182.215.101:2043/";
// export const apiUrlFaceSar ="https://persondetector.bonsazeh.gwsec.ir/";
export const apiUrlFaceSar =window.env.REACT_APP_API_FACE;
// export const apiUrlVoiceSar ="http://94.182.215.101:2045/";
// export const apiUrlVoiceSar ="https://asr.bonsazeh.gwsec.ir/";
export const apiUrlVoiceSar =window.env.REACT_APP_API_VOICE;

